export class ListRoutingConfiguration {
  constructor(
    public id: string,
    public siteType: string,
    public defaultSearchScope: string,
    public urlId: string,
    public actionBarResources: string[],
    public displayName: string,
  ) {}
}
